import { AddOnsCalInterface } from "../../interface";

export const portableBar = "Portable Bar";
export const iceCubes = "Ice and Coolers";
export const defaultAddonImg =
    "https://happiest-prod-images.s3.amazonaws.com/1726851743496_White_background.png";
export const defaultAddons: AddOnsCalInterface[] = [
    {
        name: portableBar,
        img: "https://dn16dhy0grblk.cloudfront.net/cutsomSupply/Portable%20Bars.png",
        type: "fixed",
        price: 3000,
        cost: 1000,
        id: "2",
        auto_include: true,
        description: "",
        is_btc_edit: false,
        min_price: 0,
        include_prep_time: false,
    },
    {
        name: iceCubes,
        img: "https://dn16dhy0grblk.cloudfront.net/cutsomSupply/Ice%20Cubes.png",
        type: "guests",
        price: 100,
        cost: 100,
        id: "3",
        auto_include: true,
        description: "",
        is_btc_edit: false,
        min_price: 0,
        include_prep_time: false,
    },
];

export const SECTION_HELP_VIDEOS = {
    bartender: "https://www.loom.com/embed/3ca20648329f40df91d7924ec1433b77",
    cocktails: "https://www.loom.com/embed/fa6400a14d4c444d8091ee9bc314c448",
    business: "https://www.loom.com/embed/072e6f85acd849a8887e2a685f006254",
    addOns: "https://www.loom.com/embed/ee1ce1aea6924bed827000d85fb982a8",
    estimatedRevenue: "https://www.loom.com/embed/48c8d229b1b54ce1838e927c9bb31326",
    priceCalculator: "https://www.loom.com/embed/ffbd795557b74526b3a950017d4286a9",
};

export const GUEST_RANGE_STEPS = [
    25, 50, 75, 100, 125, 150, 175, 200, 225, 250, 275, 300, 325, 350, 375, 400,
];

export const PACKAGE_INCLUDES_HTML = [
    "Includes:",
    "• Mixers",
    "• Garnishes",
    "• Cups",
    "• Straws",
    "• Napkins",
    "• Cocktail Menu",
    "• Bartender(s) plus their tools",
    "• Up to 4x signature cocktails",
].join("<br/>");

// Moved to Business section (MyBusiness.tsx) — now backed by business.custom_quote_description
// export const DEFAULT_TEXT_CUSTOM_DESCRIPTION = "Once you request a quote, the bartending company will reach out to you directly.\n\n→ They’ll discuss your event details; type, date, venue, and number of guests.\n→ You’ll review bartender packages and choose the one that best fits your event.\n→ The company will guide you through cocktail and beverage selections.\n→ You can explore add-ons to enhance your setup.\n→ Any additional information can be shared for a personalized touch.\n→ The company will prepare a detailed quote outlining costs, inclusions, and terms.\n→ Once approved, you’ll receive payment instructions and booking confirmation.\n\nBartending company will then handle all coordination and setup to ensure your event runs smoothly and stress-free.";

// Miles included at no charge; distance beyond this is billed at the package's Cost Per Mile.
export const FREE_MILES = 30;

// With "Include Beer and Wine" on, ~20% of guests drink beer/wine instead of cocktails,
// so only 80% of the calculated cocktail quantity is priced.
export const BEER_AND_WINE_COCKTAIL_RATIO = 0.8;
